<template>
<div class="smart-water-header">
    <div class="header-bg">
        <!-- 左侧装饰 -->
        <div class="header-decoration left">
            <div class="decoration-line"></div>
            <div class="decoration-dot"></div>

        </div>

        <!-- Tab栏排布在Title两侧 -->
        <div class="header-content">
            <!-- 左侧Tab -->
            <div class="tabs-left">
                <div v-for="(tab, index) in leftTabs" :key="index" :class="['tab-item', { active: activeTab === index }]" @click="switchTab(index)">
                    <div class="tab-bg">
                        <span class="tab-text">{{ tab.name }}</span>
                        <div class="tab-indicator"></div>
                    </div>
                </div>
            </div>

            <!-- 中央标题 -->
            <div class="header-title">
                <h1 class="main-title">{{ $t('智慧水务管理平台') }}</h1>
                <p class="sub-title">SMART WATER MANAGER PLATFORM</p>
            </div>

            <!-- 右侧Tab -->
            <div class="tabs-right">
                <div v-for="(tab, index) in rightTabs" :key="index + 3" :class="['tab-item', { active: activeTab === (index + 3) }]" @click="switchTab(index + 3)">
                    <div class="tab-bg">
                        <span class="tab-text">{{ tab.name }}</span>
                        <div class="tab-indicator"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧装饰 -->
        <div class="header-decoration right">
            <div class="decoration-dot"></div>
            <div class="decoration-line"></div>
        </div>
        <!-- 快捷键 -->
        <div style="position: absolute;right: 20px;">
            <shortcut-menu @refresh="refreshPage"></shortcut-menu>
        </div>
    </div>
</div>
</template>

<script>
import shortcutMenu from './shortcutMenu.vue'

export default {
    name: 'SmartWaterHeader',
    components: { shortcutMenu },
    data() {
        return {
            activeTab: 0
        }
    },
    computed: {
        // i18n：页签名称使用 computed 以响应语言切换
        leftTabs() {
            return [{
                    name: this.$t('供水分析'),
                    key: 'supply'
                },
                {
                    name: this.$t('运营分析'),
                    key: 'operation'
                },
                {
                    name: this.$t('抄表管理'),
                    key: 'meterreading'
                }
            ]
        },
        rightTabs() {
            return [{
                    name: this.$t('DMA概览'),
                    key: 'main'
                },
                {
                    name: this.$t('工单管理'),
                    key: 'workorder'
                },
                {
                    name: this.$t('巡检管理'),
                    key: 'inspection'
                },
                {
                    name: this.$t('工艺控制'),
                    key: 'controller'
                }
            ]
        },
        tabs() {
            return [{
                    name: this.$t('供水分析'),
                    key: 'supply'
                },
                {
                    name: this.$t('运营分析'),
                    key: 'operation'
                },
                {
                    name: this.$t('抄表管理'),
                    key: 'meterreading'
                },
                {
                    name: this.$t('DMA概览'),
                    key: 'main'
                },
                {
                    name: this.$t('工单管理'),
                    key: 'workorder'
                },
                {
                    name: this.$t('巡检管理'),
                    key: 'inspection'
                },
                {
                    name: this.$t('工艺控制'),
                    key: 'controller'
                }

            ]
        }
    },
    methods: {
        switchTab(index, key) {
            this.activeTab = index
            this.$emit('tab-change', this.tabs[index].key)
        }
    }
}
</script>

<style lang="less" scoped>
.smart-water-header {
    width: 100%;
    height: 60px;
    background: linear-gradient(180deg, #001a33 0%, #000d1a 100%);
    border-bottom: 1px solid rgba(0, 150, 255, 0.3);
    position: relative;
    overflow: hidden;

    .header-bg {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        padding: 0 60px;
        position: relative;

        .header-decoration {
            display: flex;
            align-items: center;

            &.left {
                .decoration-line {
                    width: 150px;
                    height: 2px;
                    background: linear-gradient(90deg, transparent, #0096ff);
                    margin-right: 10px;
                }
            }

            &.right {
                .decoration-line {
                    width: 150px;
                    height: 2px;
                    background: linear-gradient(90deg, #0096ff, transparent);
                    margin-left: 10px;
                }
            }

            .decoration-dot {
                width: 6px;
                height: 6px;
                background: #0096ff;
                border-radius: 50%;
                box-shadow: 0 0 12px #0096ff;
            }
        }

        .header-content {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 40px;

            .tabs-left,
            .tabs-right {
                display: flex;
                gap: 15px;
            }

            .tab-item {
                position: relative;
                cursor: pointer;
                transition: all 0.3s ease;

                .tab-bg {
                    padding: 10px 20px;
                    background: rgba(0, 100, 200, 0.1);
                    border: 1px solid rgba(0, 150, 255, 0.3);
                    border-radius: 25px;
                    backdrop-filter: blur(10px);
                    position: relative;
                    overflow: hidden;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(0, 150, 255, 0.2), transparent);
                        transition: left 0.5s ease;
                    }

                    .tab-text {
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.8);
                        font-weight: 500;
                        position: relative;
                        z-index: 2;
                        transition: all 0.3s ease;
                    }

                    .tab-indicator {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 0;
                        height: 2px;
                        background: linear-gradient(90deg, transparent, #0096ff, transparent);
                        transition: width 0.3s ease;
                    }
                }

                &:hover .tab-bg {
                    border-color: #0096ff;
                    box-shadow: 0 0 20px rgba(0, 150, 255, 0.2);

                    &::before {
                        left: 100%;
                    }

                    .tab-text {
                        color: #0096ff;
                        text-shadow: 0 0 8px rgba(0, 150, 255, 0.5);
                    }
                }

                &.active .tab-bg {
                    background: rgba(0, 150, 255, 0.2);
                    border-color: #0096ff;
                    box-shadow: 0 0 25px rgba(0, 150, 255, 0.3);

                    .tab-text {
                        color: #0096ff;
                        font-weight: bold;
                        text-shadow: 0 0 12px rgba(0, 150, 255, 0.7);
                    }

                    .tab-indicator {
                        width: 100%;
                    }
                }
            }

            .header-title {
                text-align: center;
                min-width: 400px;

                .main-title {
                    font-size: 32px;
                    font-weight: 700;
                    color: #00c3ffff;
                    margin: 0;
                    text-shadow: 0 0 20px rgba(0, 149, 255, 0.7);
                    letter-spacing: 3px;
                    background: linear-gradient(135deg, #00c3ffff, #02b0dbff);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                .sub-title {
                    font-size: 11px;
                    color: rgba(0, 150, 255, 0.6);
                    margin: 2px 0 0 0;
                    letter-spacing: 2px;
                    font-weight: 300;
                }
            }
        }
    }

    // 科技感背景动画
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
            radial-gradient(circle at 20% 50%, rgba(0, 150, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 50%, rgba(0, 100, 200, 0.05) 0%, transparent 50%),
            repeating-linear-gradient(90deg, transparent, transparent 1px, rgba(0, 150, 255, 0.02) 1px, rgba(0, 150, 255, 0.02) 2px);
        pointer-events: none;
    }

    // 扫描线效果
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, #0096ff, transparent);
        animation: scan 3s linear infinite;
        pointer-events: none;
    }
}

@keyframes scan {
    0% {
        top: 0;
        opacity: 0;
    }

    10% {
        opacity: 1;
    }

    90% {
        opacity: 1;
    }

    100% {
        top: 100%;
        opacity: 0;
    }
}
</style>
